{
  "add": "Kandidaat toevoegen",
  "deceased": {
    "singular": "Overleden kandidaat",
    "plural": "Overleden kandidaten"
  },
  "Female": "v",
  "list": {
    "plural": "Kandidatenlijsten",
    "singular": "Kandidatenlijst"
  },
  "locality": "Woonplaats",
  "Male": "m",
  "title": {
    "singular": "Kandidaat",
    "plural": "Kandidaten"
  },
  "X": "x"
}
